/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：245
 */

module.exports = {
  hide: "style_hide__27-Md",
  "coco-widget-wrapper": "style_coco-widget-wrapper__7SU9C",
  "coco-child-widget": "style_coco-child-widget__1GfnR",
  "coco-child-widget-selected": "style_coco-child-widget-selected__3tcHj",
  "coco-child-widget-full": "style_coco-child-widget-full__1oQJO",
  radioWidget: "style_radioWidget__TXpgd",
  headline: "style_headline__25aOV",
  defaultRadio: "style_defaultRadio__2BDa0",
  buttonRadio: "style_buttonRadio__3vFko",
  inner: "style_inner__3dVzr",
  selected: "style_selected__3FX8T",
  defaultRadioSelected: "style_defaultRadioSelected__18jbk",
  buttonRadioInner: "style_buttonRadioInner__2ZxPf"
}
